import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { PaymentContext } from 'context/Context';
import { getItemFromStore, setItemToStore } from 'helpers/utils';
import { useParams } from 'react-router-dom';

const localData = getItemFromStore('payments', null);

const PaymentProvider = ({ children }) => {
 const { type, id } = useParams();
 const [contract, setContract] = useState(localData?.type !== type ? {} : localData?.contracts?.find(e => e._id === id) ?? {});
 const [contracts, setContracts] = useState(contract?._id ? localData?.contracts : []);
 const [payerDetails, setPayerDetails] = useState(getItemFromStore('payments', {})?.payerDetails);
 const [acceptance, setAcceptance] = useState({});

 useEffect(() => {
  setItemToStore('payments', { type, contracts, contract, payerDetails });
 }, [contracts, contract, payerDetails]);

 const value = { contract, setContract, contracts, setContracts, payerDetails, setPayerDetails, acceptance, setAcceptance };
 return <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>;
};

PaymentProvider.propTypes = {
 children: PropTypes.node.isRequired
};

export default PaymentProvider;
